import useAccount from './useAccount';
import { AccountType } from '../enum/AccountType';

export default function useProfileReady() {
  const { accountResponse } = useAccount();

  let result = true;

  if (!accountResponse?.type) {
    return false;
  }

  if (!accountResponse?.agentProfileInfo?.taxationSystem) {
    return false;
  }

  if (accountResponse?.type === AccountType.PERSON) {
    const person = accountResponse?.person;
    if (!person) {
      return false;
    }
    const hasPassport = person?.passportDocuments?.length > 0;
    const hasRegister = Boolean(accountResponse?.bankDetails?.number);
    const { passportSeries, passportNumber, inn, addressLegal } = person;
    const personDataFilled = [
      passportSeries,
      passportNumber,
      inn,
      addressLegal?.street,
    ].every(Boolean);

    result = hasPassport && hasRegister && personDataFilled;
  }

  return result;
}
